if (!customElements.get('blog-tag-nav')) {
  class BlogTagNav extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.listEl = this.querySelector('.blog-tag-nav__list');
      if (this.listEl && theme?.utils?.initDragScroll) {
        this._dragScroll = theme.utils.initDragScroll(this.listEl);
      }
    }

    disconnectedCallback() {
      if (this._dragScroll) {
        this._dragScroll.destroy();
        this._dragScroll = null;
      }
    }
  }

  customElements.define('blog-tag-nav', BlogTagNav);
}

if (!customElements.get('blog-load-more')) {
  class BlogLoadMore extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.btn = this.querySelector('.blog-load-more__btn');
      if (this.btn) this.btn.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      if (this.btn) this.btn.removeEventListener('click', this.handleClick);
    }

    async handleClick() {
      const nextPage = parseInt(this.dataset.nextPage, 10);
      const url = new URL(window.location.href);
      url.searchParams.set('page', nextPage);
      url.searchParams.set('sections', 'blog');

      this.btn.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(url.toString());
        const data = await response.json();
        const html = theme.utils.domParser.parseFromString(data.blog, 'text/html');

        const newCards = html.querySelectorAll('.blog-card');
        const grid = document.querySelector('.blog-index__grid');
        newCards.forEach(card => grid.appendChild(card));

        const nextBtn = html.querySelector('blog-load-more');
        if (nextBtn) {
          this.dataset.nextPage = nextBtn.dataset.nextPage;
          this.btn.removeAttribute('aria-busy');
        } else {
          this.remove();
        }
      } catch (e) {
        this.btn.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('blog-load-more', BlogLoadMore);
}
